// Sidebar badge: Offline / Syncing / X to Sync / conflict.
import React from "react";
import { connect } from "react-redux";
import { Badge } from "framework7-react";
import { PendingSyncTrigger } from "./PendingSyncSheet";

const mapStateToProps = (state) => ({
  offline: state.offline_status || {},
});

const SyncStatusChip = ({ offline }) => {
  const { online, pendingCount = 0, conflictCount = 0, syncing } = offline;

  let label = "Online";
  let color = "green";

  if (!online) {
    label = pendingCount > 0 ? "Saved on phone" : "Offline";
    color = "orange";
  } else if (syncing) {
    label = "Syncing…";
    color = "blue";
  } else if (conflictCount > 0) {
    label = `${conflictCount} conflict${conflictCount === 1 ? "" : "s"}`;
    color = "red";
  } else if (pendingCount > 0) {
    label = `${pendingCount} to Sync`;
    color = "orange";
  }

  return (
    // Sidebar pages have no navbar, so clear the status bar ourselves (F7 puts the safe area in navbars)
    <div
      style={{
        padding: "calc(8px + var(--f7-safe-area-top, 0px)) 16px 8px",
        display: "flex",
        gap: 6,
        alignItems: "center",
      }}
    >
      <PendingSyncTrigger>
        <Badge color={color}>{label}</Badge>
        {pendingCount > 0 && (!online || syncing || conflictCount > 0) && (
          <Badge color="orange">{pendingCount} to Sync</Badge>
        )}
      </PendingSyncTrigger>
    </div>
  );
};

export default connect(mapStateToProps)(SyncStatusChip);
